import type {
  RemoveFromTeamMutation,
  RemoveFromTeamMutationVariables
} from './__generated__/RemoveFromTeamMutation'
import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'

const mutation: TypedDocumentNode<
  RemoveFromTeamMutation,
  RemoveFromTeamMutationVariables
> = gql`
  mutation RemoveFromTeamMutation($input: RemoveFromTeamInput!) {
    removeFromTeam(input: $input) {
      status
    }
  }
`

export function removeFromTeamMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      RemoveFromTeamMutation,
      RemoveFromTeamMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
